import script from "./Calendar.vue?vue&type=script&setup=true&lang=js"
export * from "./Calendar.vue?vue&type=script&setup=true&lang=js"

import "./Calendar.vue?vue&type=style&index=0&id=24f0e68a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24f0e68a"]])

export default __exports__